import React from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Button } from 'antd';
import dayjs from 'dayjs';
import { ICollectorReportRes } from '@/interfaces/report';
import { ExportOutlined } from '@ant-design/icons';
import {
  getPaymentReceivedStatusName,
  getPaymentTypeName,
} from '@/helpers/orderHelper';
import { formatDate } from '@/utils/dataUtils';

interface IProps {
  data: ICollectorReportRes[];
}

const ExcelExport = ({ data }: IProps) => {
  const handleExport = async () => {
    // Create a new workbook and add a worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    // Add custom headers with color
    worksheet.columns = [
      { header: '#', key: 'id', width: 10 },
      { header: 'Order Code', key: 'orderCode', width: 20 },
      { header: 'Inv No.', key: 'ivNo', width: 20 },
      { header: 'Customer Code', key: 'customerCode', width: 15 },
      { header: 'Customer name', key: 'customerName', width: 10 },
      { header: 'BU', key: 'businessUnitName', width: 20 },
      { header: 'Sales (THB)', key: 'orderAmount', width: 20 },
      { header: 'ประเภท', key: 'paymentType', width: 20 },
      { header: 'วันที่สั่งซื้อ', key: 'orderDate', width: 20 },
      { header: 'วันที่วางบิล', key: 'billingDate', width: 20 },
      { header: 'วันที่ครบกำหนด', key: 'dueDate', width: 20 },
      { header: 'วันที่รับเงิน', key: 'paidDate', width: 20 },
      { header: 'ยอดรับ', key: 'paidAmount', width: 20 },
      { header: 'คงค้าง', key: 'diff', width: 20 },
      { header: 'สถานะ', key: 'status', width: 20 },
    ];

    // Style the header row
    worksheet.getRow(1).eachCell(cell => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }; // White text
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF0000FF' }, // Blue background
      };
    });

    // Add data to the worksheet
    data.forEach((item: ICollectorReportRes, index: number) => {
      worksheet.addRow({
        ...item,
        id: index + 1,
        diff: Number(item.orderAmount - item.paidAmount),
        paymentType: getPaymentTypeName(item.paymentType),
        orderDate: formatDate(dayjs(item.orderDate)),
        paidDate: formatDate(dayjs(item.paidDate)),
        billingDate: formatDate(dayjs(item.billingDate)),
        dueDate: formatDate(dayjs(item.dueDate)),
        status: getPaymentReceivedStatusName(item.status),
      });
      // const safetyCell = worksheet.getCell(`F${rowIndex}`);
      // if (item.remainStock < item.safetyStock) {
      //   safetyCell.font = { color: { argb: 'FFFF0000' } };
      // }
      // const monthCell = worksheet.getCell(`G${rowIndex}`);
      // if (item.remainStock < item.orderQty1) {
      //   monthCell.font = { color: { argb: 'FFFF0000' } };
      // }
      // const month3Cell = worksheet.getCell(`H${rowIndex}`);
      // if (item.remainStock < item.orderQty2) {
      //   month3Cell.font = { color: { argb: 'FFFF0000' } };
      // }
    });

    // Generate the Excel file and trigger the download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `collector-report-${dayjs().format('YYYY-MM-DD')}.xlsx`);
  };

  return (
    <div>
      <Button type="primary" ghost onClick={handleExport}>
        <ExportOutlined /> Export to Excel
      </Button>
    </div>
  );
};

export default ExcelExport;
